import {
  Button,
  Dialog,
  DialogBody,
  Typography,
} from '@material-tailwind/react';
import { useNavigate } from 'react-router-dom';

interface GuestFreeTrialModalProps {
  open: boolean;
  onClose: () => void;
}

const GuestFreeTrialModal = ({ open, onClose }: GuestFreeTrialModalProps) => {
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      handler={onClose}
      size="xs"
      className="m-auto w-[calc(100%-32px)] max-w-[400px] rounded-[20px]"
    >
      <DialogBody className="max-h-[calc(100dvh-32px)] overflow-y-auto px-5 pb-6 pt-6">
        <div className="flex flex-col items-center">
          {/* 마스코트 */}
          <div className="mb-4 flex h-16 w-16 items-center justify-center overflow-hidden">
            <img
              src="/images/free-trial/bready.png"
              alt="bready"
              className="h-full w-full object-contain"
            />
          </div>

          {/* 타이틀 */}
          <Typography className="text-center text-[20px] font-extrabold leading-[1.35] text-gray-900">
            무료체험은 로그인 후
            <br />
            신청할 수 있어요
          </Typography>

          {/* 설명 */}
          <Typography className="mt-3 text-center text-[13px] font-normal leading-5 text-gray-700">
            자녀 이름으로 체험 페이지를 만들어
            <br />
            진행 상황과 결과를 저장해 드려요.
          </Typography>

          {/* 버튼 */}
          <div className="mt-6 flex w-full flex-col gap-2.5">
            <Button
              ripple={false}
              onClick={() => navigate('/signin')}
              className="h-11 w-full rounded-lg bg-[#6737F4] py-0 text-sm font-bold normal-case text-white shadow-none hover:shadow-none focus:shadow-none"
            >
              로그인
            </Button>

            <Button
              ripple={false}
              variant="outlined"
              onClick={() => navigate('/signup')}
              className="h-11 w-full rounded-lg border-[#9B7FFF] py-0 text-sm font-bold normal-case text-[#5B35DD] shadow-none hover:shadow-none focus:shadow-none"
            >
              회원가입하고 시작하기
            </Button>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  );
};

export default GuestFreeTrialModal;
